// src/api/roleFieldAssignmentApi.js

import axios from './axios';
import { handleApiError } from './apiErrorHandler';

export default {
  // Fetch field assignments for the current authenticated user's role & user type
  getMyFieldAssignments: async () => {
    try {
      const response = await axios.get('/role-field-assignments/my-fields');
      return { success: true, data: response.data };
    } catch (error) {
      return handleApiError(error);
    }
  },

  // Create a new role-field assignment
  createRoleFieldAssignment: async (data) => {
    try {
      const response = await axios.post('/role-field-assignments', data);
      return { success: true, data: response.data };
    } catch (error) {
      return handleApiError(error);
    }
  },

  // Update an existing role-field assignment
  updateRoleFieldAssignment: async (id, data) => {
    try {
      const response = await axios.put(`/role-field-assignments/${id}`, data);
      return { success: true, data: response.data };
    } catch (error) {
      return handleApiError(error);
    }
  },

  // Get a specific role-field assignment by ID
  getRoleFieldAssignmentById: async (id) => {
    try {
      const response = await axios.get(`/role-field-assignments/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return handleApiError(error);
    }
  },

  // Get all role-field assignments
  getAllRoleFieldAssignments: async () => {
    try {
      const response = await axios.get('/role-field-assignments');
      return { success: true, data: response.data };
    } catch (error) {
      return handleApiError(error);
    }
  },

  // Delete a role-field assignment
  deleteRoleFieldAssignment: async (id) => {
    try {
      const response = await axios.delete(`/role-field-assignments/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return handleApiError(error);
    }
  },
};
